module.exports = __webpack_public_path__ + "static/media/Alicia P.2bd89fce.png";